import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-355f86f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cookie_disclosure--grid" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Our website uses cookies to improve your experience and personalize content.", -1 /* HOISTED */))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Some cookies may collect personal data, which we use in accordance with our privacy policy.", -1 /* HOISTED */))
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "cookie_disclosure--button_container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["cookie_disclosure--container", _ctx.containerClasses])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("p", null, [
          _createTextVNode("You can manage your cookie preferences using the buttons here. You can "),
          _createElementVNode("a", { href: _ctx.privacyPolicyPath }, "view our privacy policy here.", 8 /* PROPS */, _hoisted_4)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("a", {
          class: _normalizeClass(["cookie_disclosure--button cookie_disclosure--button-all", {'cookie_disclosure--button-disabled': _ctx.isAllCookiesDisabled}]),
          href: "#",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.setUserSetting('all')), ["prevent"]))
        }, " ALL COOKIES ", 2 /* CLASS */),
        _createElementVNode("a", {
          class: _normalizeClass(["cookie_disclosure--button", {'cookie_disclosure--button-disabled': _ctx.isRequiredCookiesDisabled}]),
          href: "#",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.setUserSetting('required')), ["prevent"]))
        }, " REQUIRED COOKIES ", 2 /* CLASS */)
      ])
    ])
  ], 2 /* CLASS */))
}